"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasketsSDK = exports.BasketInstructions = void 0;
const web3_js_1 = require("@solana/web3.js");
const anchor_1 = require("@coral-xyz/anchor");
const basketsIDL_1 = require("./basketsIDL");
const basketState_1 = require("./basketState");
const config_1 = require("./config");
const utils_1 = require("./utils");
const buyState_1 = require("./buyState");
const simulation_1 = require("./simulation");
const splTokenHelpers_1 = require("./splTokenHelpers");
const nodewallet_1 = __importDefault(require("@coral-xyz/anchor/dist/cjs/nodewallet"));
const instructionsBuilder_1 = require("./instructionsBuilder");
exports.BasketInstructions = __importStar(require("./basketInstructions"));
__exportStar(require("./config"), exports);
__exportStar(require("./basketState"), exports);
__exportStar(require("./buyState"), exports);
__exportStar(require("./utils"), exports);
class BasketsSDK {
    constructor(connection, program, tokenList, wallet) {
        this.jupAPIkey = "https://quote-api.jup.ag/v6/";
        this.connection = connection;
        this.wallet = wallet;
        this.program = program;
        this.tokenList = tokenList;
        this.lamports = config_1.ADDITIONAL_FEE;
    }
    static init(connection, wallet) {
        return __awaiter(this, void 0, void 0, function* () {
            let provider = new anchor_1.AnchorProvider(connection, wallet ? wallet : new nodewallet_1.default(web3_js_1.Keypair.generate()), {
                skipPreflight: true,
                preflightCommitment: "recent",
                commitment: "processed",
            });
            let program = new anchor_1.Program(basketsIDL_1.IDL, config_1.BASKETS_PROGRAM_ID, provider);
            let tokenList = yield (0, utils_1.fetchTokenList)(program);
            return new BasketsSDK(connection, program, tokenList, wallet);
        });
    }
    setWallet(wallet) {
        return __awaiter(this, void 0, void 0, function* () {
            this.wallet = wallet;
            let provider = new anchor_1.AnchorProvider(this.connection, wallet, {
                skipPreflight: true,
                preflightCommitment: "recent",
                commitment: "recent",
            });
            this.program = new anchor_1.Program(basketsIDL_1.IDL, config_1.BASKETS_PROGRAM_ID, provider);
        });
    }
    setPriorityFee(lamports) {
        this.lamports = lamports;
    }
    setJupAPIKey(apiKey) {
        this.jupAPIkey = apiKey;
    }
    loadFromPubkey(pubkey) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield basketState_1.Basket.loadFromPubkey(this.program, pubkey);
        });
    }
    getCurrentCompositions(baskets) {
        return __awaiter(this, void 0, void 0, function* () {
            let oraclePriceData = yield (0, utils_1.getOraclePrices)(this.program, this.tokenList);
            let parsed = baskets.map(basket => (0, utils_1.getCurrentComposition)(basket, this.tokenList, oraclePriceData));
            yield Promise.all(parsed.map(x => (0, utils_1.tryMetadata)(x))).then(metadatas => {
                for (let i = 0; i < parsed.length; i++)
                    parsed[i].metadata = metadatas[i];
            });
            return parsed;
        });
    }
    findBaskets(filters) {
        return __awaiter(this, void 0, void 0, function* () {
            let accountFilters = [{ dataSize: 10208 }];
            accountFilters.push({ memcmp: {
                    offset: 112,
                    bytes: "11111111"
                } });
            accountFilters = [...accountFilters, ...filters.map(filter => {
                    return {
                        memcmp: {
                            offset: (filter.filterType == "host") ? 128 : 16,
                            bytes: filter.filterPubkey.toBase58(),
                        }
                    };
                })];
            let accounts = yield (0, utils_1.getFilteredProgramAccounts)(this.connection, accountFilters);
            return accounts
                .map(account => basketState_1.Basket.loadFromRawData(this.program, account));
        });
    }
    findActiveSellStates(user) {
        return __awaiter(this, void 0, void 0, function* () {
            let accounts = yield (0, utils_1.getFilteredProgramAccounts)(this.connection, [
                { dataSize: 10208 },
                { memcmp: {
                        offset: 16,
                        bytes: user.toBase58()
                    } },
                { memcmp: {
                        offset: 112,
                        bytes: "Ahg1opVcGX",
                    } },
            ]);
            return accounts
                .map(account => basketState_1.Basket.loadFromRawData(this.program, account));
        });
    }
    findActiveBuyStates(user) {
        return __awaiter(this, void 0, void 0, function* () {
            let accounts = yield (0, utils_1.getFilteredProgramAccounts)(this.connection, [
                { dataSize: 680 },
                { memcmp: {
                        offset: 40,
                        bytes: user.toBase58()
                    } }
            ]);
            return yield buyState_1.BuyState.loadMultiple(this.program, accounts);
        });
    }
    fetchAllBuyStates(filters) {
        return __awaiter(this, void 0, void 0, function* () {
            let accountFilters = [{ dataSize: 680 }];
            accountFilters = [...accountFilters, ...filters.map(filter => {
                    return {
                        memcmp: {
                            offset: (filter.filterType == "host") ? 104 : 72,
                            bytes: filter.filterPubkey.toBase58(),
                        }
                    };
                })];
            let accounts = yield (0, utils_1.getFilteredProgramAccounts)(this.connection, accountFilters);
            return yield buyState_1.BuyState.loadMultiple(this.program, accounts);
        });
    }
    fetchBuyStateFromPubkey(pubkey) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield buyState_1.BuyState.loadFromPubkey(this.program, pubkey);
        });
    }
    fetchAllSellStates(filters) {
        return __awaiter(this, void 0, void 0, function* () {
            let accountFilters = [{ dataSize: 10208 }];
            accountFilters.push({ memcmp: {
                    offset: 112,
                    bytes: "Ahg1opVcGX"
                } });
            accountFilters = [...accountFilters, ...filters.map(filter => {
                    return {
                        memcmp: {
                            offset: (filter.filterType == "host") ? 128 : 16,
                            bytes: filter.filterPubkey.toBase58(),
                        }
                    };
                })];
            let accounts = yield (0, utils_1.getFilteredProgramAccounts)(this.connection, accountFilters);
            return accounts
                .map(account => basketState_1.Basket.loadFromRawData(this.program, account));
        });
    }
    fetchAllHoldings(user) {
        return __awaiter(this, void 0, void 0, function* () {
            let tokenAccountsRaw = yield this.connection.getTokenAccountsByOwner(new web3_js_1.PublicKey(user), { programId: new web3_js_1.PublicKey(splTokenHelpers_1.TOKEN_PROGRAM_ID) }, "processed");
            let tokenAccountsDecoded = tokenAccountsRaw.value.map(account => {
                return {
                    mint: new web3_js_1.PublicKey(account.account.data.slice(0, 32)),
                    balance: parseInt(new anchor_1.BN(account.account.data.slice(64, 72), "le").toString()),
                };
            });
            let basketsRaw = yield (0, utils_1.getFilteredProgramAccounts)(this.connection, [
                { dataSize: 10208 },
                {
                    memcmp: {
                        offset: 112,
                        bytes: "11111111"
                    }
                }
            ]);
            let basketsDecoded = basketsRaw.map(account => {
                return {
                    decoded: this.program.coder.accounts.decode("fundState", account.account.data),
                    pubkey: account.pubkey
                };
            });
            let basketHoldings = [];
            for (let i = 0; i < basketsDecoded.length; i++) {
                let ataIndex = tokenAccountsDecoded
                    .findIndex(x => x.mint.toBase58() == basketsDecoded[i].decoded.fundToken.toBase58());
                if (ataIndex == -1)
                    continue;
                basketHoldings.push({
                    basketAddress: basketsDecoded[i].pubkey.toBase58(),
                    mint: basketsDecoded[i].decoded.fundToken.toBase58(),
                    balance: tokenAccountsDecoded[ataIndex].balance / 10 ** 6,
                    basketData: basketsDecoded[i].decoded,
                });
            }
            return basketHoldings;
        });
    }
    getTokenListData() {
        return this.tokenList.filter(x => x.isLive == true);
    }
    tokenIdFromMint(tokenMint) {
        for (let i = 0; i < this.tokenList.length; i++)
            if (this.tokenList[i].tokenMint == tokenMint)
                return this.tokenList[i].id;
        throw new config_1.BasketError("Token not supported by Symmetry Engine");
    }
    createBasket(createBasketParams) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.wallet)
                throw new config_1.BasketError("Wallet not provided");
            return yield basketState_1.Basket.create(this.program, this.connection, this.wallet, this.tokenList, createBasketParams, this.lamports);
        });
    }
    simulateBasket(createBasketParams, simulationDays) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield (0, simulation_1.simulate)(this.program, config_1.DATABASE_ADDESS, config_1.TOKEN_LIST_ADDRESS, createBasketParams, simulationDays);
        });
    }
    editBasket(basket, editBasketParams) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.wallet)
                throw new config_1.BasketError("Wallet not provided");
            return yield basket.edit(this.program, this.connection, this.wallet, this.tokenList, editBasketParams, this.lamports);
        });
    }
    setMetadata(basket_1, symbol_1, name_1) {
        return __awaiter(this, arguments, void 0, function* (basket, symbol, name, uri = "") {
            if (!this.wallet)
                throw new config_1.BasketError("Wallet not provided");
            return yield basket.setMetaData(this.program, this.wallet, symbol, name, uri, this.lamports);
        });
    }
    editManager(basket, newManager) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.wallet)
                throw new config_1.BasketError("Wallet not provided");
            return yield basket.editManager(this.program, this.connection, this.wallet, newManager, this.lamports);
        });
    }
    // async simpleEditBasket(
    //     basket: Basket,
    //     basketParams: SimpleEditParams,
    // ): Promise<TransactionSignature[]> {
    //     if (!this.wallet)
    //         throw new BasketError("Wallet not provided");
    //     return await basket.simpleEdit(
    //         this.program,
    //         this.connection,
    //         this.wallet,
    //         this.tokenList,
    //         basketParams,
    //         this.lamports,
    //     )
    // }
    closeBasket(basket) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.wallet)
                throw new config_1.BasketError("Wallet not provided");
            return yield basket.close(this.program, this.wallet, this.lamports);
        });
    }
    refilterBasketInstruction(basket) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            //@ts-ignore
            return yield refilterInstruction(this.program, basket.ownAddress, (_a = this.wallet) === null || _a === void 0 ? void 0 : _a.publicKey);
        });
    }
    // async refilterBasket(basket: Basket): Promise<TransactionSignature> {
    //     if (!this.wallet)
    //         throw new BasketError("Wallet not provided");
    //     return await basket.refilter(
    //         this.program,
    //         this.wallet,
    //         this.lamports,
    //     );
    // }
    reweightBasketInstruction(basket) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            //@ts-ignore
            return yield reweightInstruction(this.program, basket.ownAddress, (_a = this.wallet) === null || _a === void 0 ? void 0 : _a.publicKey);
        });
    }
    // async reweightBasket(basket: Basket): Promise<TransactionSignature> {
    //     if (!this.wallet)
    //         throw new BasketError("Wallet not provided");
    //     return await basket.reweight(
    //         this.program,
    //         this.wallet,
    //         this.lamports,
    //     );
    // }
    rebalanceBasketToken(basket, token) {
        return __awaiter(this, void 0, void 0, function* () {
            let oraclePriceData = yield (0, utils_1.getOraclePrices)(this.program, this.tokenList);
            //@ts-ignore
            let tokenSettings = this.tokenList.find(x => x.tokenMint == token.toBase58());
            if (!this.wallet)
                throw new config_1.BasketError("Wallet not provided");
            if (!tokenSettings)
                throw new config_1.BasketError("Token not supported");
            let timestamp = yield this.connection.getBlockTime(yield this.connection.getSlot("finalized")).catch((e) => null);
            let rebalanceInfos = basket.getRebalanceInfo(this.program, this.tokenList, oraclePriceData, timestamp ? timestamp : 2000000000, (this.wallet.publicKey.equals(basket.data.manager) && basket.data.activelyManaged.toNumber() == 1));
            let rebalanceInfo = rebalanceInfos.find(info => info.tokenId == tokenSettings.id);
            if (!rebalanceInfo)
                throw new config_1.BasketError("Token not in composition");
            let jupSwapData = yield (0, utils_1.generateJupSwapInstruction)(rebalanceInfo, basket.data.rebalanceSlippage.toNumber(), this.connection, rebalanceInfo.side == config_1.Side.To ?
                oraclePriceData[rebalanceInfo.tokenId] / 10 ** this.tokenList[rebalanceInfo.tokenId].decimals :
                oraclePriceData[0] / 10 ** this.tokenList[0].decimals, rebalanceInfo.side == config_1.Side.From ?
                oraclePriceData[rebalanceInfo.tokenId] / 10 ** this.tokenList[rebalanceInfo.tokenId].decimals :
                oraclePriceData[0] / 10 ** this.tokenList[0].decimals, rebalanceInfo.tokenId == 48 ? this.tokenList[5].tokenMint : this.tokenList[1].tokenMint, rebalanceInfo.tokenId == 48 ? this.tokenList[5].pdaTokenAccount : this.tokenList[1].pdaTokenAccount, this.jupAPIkey).catch((e) => { console.log("JUP SWAP DATA", e.message); return null; });
            if (!jupSwapData)
                throw new config_1.BasketError("Couldn't load quote.");
            return yield basket.rebalanceSingle(this.program, this.wallet, this.tokenList, jupSwapData, rebalanceInfo, this.lamports);
        });
    }
    rebalanceBasket(basket) {
        return __awaiter(this, void 0, void 0, function* () {
            let oraclePriceData = yield (0, utils_1.getOraclePrices)(this.program, this.tokenList);
            if (!this.wallet)
                throw new config_1.BasketError("Wallet not provided");
            let timestamp = yield this.connection.getBlockTime(yield this.connection.getSlot("finalized")).catch((e) => null);
            let rebalanceInfos = basket.getRebalanceInfo(this.program, this.tokenList, oraclePriceData, timestamp ? timestamp : 2000000000, (this.wallet.publicKey.equals(basket.data.manager) && basket.data.activelyManaged.toNumber() == 1));
            let jupSwapDatas = yield Promise.all(rebalanceInfos.map(rebalanceInfo => (0, utils_1.generateJupSwapInstruction)(rebalanceInfo, basket.data.rebalanceSlippage.toNumber(), this.connection, rebalanceInfo.side == config_1.Side.To ?
                oraclePriceData[rebalanceInfo.tokenId] / 10 ** this.tokenList[rebalanceInfo.tokenId].decimals :
                oraclePriceData[0] / 10 ** this.tokenList[0].decimals, rebalanceInfo.side == config_1.Side.From ?
                oraclePriceData[rebalanceInfo.tokenId] / 10 ** this.tokenList[rebalanceInfo.tokenId].decimals :
                oraclePriceData[0] / 10 ** this.tokenList[0].decimals, rebalanceInfo.tokenId == 48 ? this.tokenList[5].tokenMint : this.tokenList[1].tokenMint, rebalanceInfo.tokenId == 48 ? this.tokenList[5].pdaTokenAccount : this.tokenList[1].pdaTokenAccount, this.jupAPIkey).catch((e) => { console.log("JUP SWAP DATA", e.message); return null; })));
            let txsToSend = [];
            const lookupTableAccount = (yield this.connection.getAddressLookupTable(config_1.BASKETS_LOOKUP_TABLE)).value;
            yield basket.rebalanceTo(this.program, this.wallet, this.tokenList, //@ts-ignore
            jupSwapDatas, rebalanceInfos, lookupTableAccount, this.lamports).then(result => txsToSend.push(...result));
            let toSwaps = txsToSend.length;
            if (basket.data.sellState.toNumber() == 0)
                yield basket.rebalanceFrom(this.program, this.wallet, this.tokenList, //@ts-ignore
                jupSwapDatas, rebalanceInfos, lookupTableAccount, this.lamports).then(result => txsToSend.push(...result));
            let blockhash = (yield this.connection.getLatestBlockhash()).blockhash;
            let signedTransactions = yield (0, utils_1.signVersionedTransactions)(this.wallet, txsToSend.map(tx => new web3_js_1.VersionedTransaction(new web3_js_1.TransactionMessage({
                payerKey: tx.payerKey,
                recentBlockhash: blockhash,
                instructions: tx.instructions,
            }).compileToV0Message(tx.lookupTables))));
            let rebalanceTo = yield (0, utils_1.sendSignedTransactions)(this.connection, signedTransactions.slice(0, toSwaps), 0);
            let rebalanceFrom = yield (0, utils_1.sendSignedTransactions)(this.connection, signedTransactions.slice(toSwaps, signedTransactions.length), 0);
            let resultTxs = [...rebalanceFrom, ...rebalanceTo];
            if (resultTxs.length > 0)
                yield (0, utils_1.confirmTransaction)(this.connection, resultTxs[resultTxs.length - 1]).catch(() => { });
            return resultTxs;
        });
    }
    flashRebalance(basket_1) {
        return __awaiter(this, arguments, void 0, function* (basket, mIn = 100, cap = 500) {
            if (!this.wallet)
                throw new config_1.BasketError("Wallet not provided");
            let oraclePriceData = yield (0, utils_1.getOraclePrices)(this.program, this.tokenList);
            let forceRebalance = (this.wallet.publicKey.equals(basket.data.manager) && basket.data.activelyManaged.toNumber() == 1);
            let timestamp = yield this.connection.getBlockTime(yield this.connection.getSlot("finalized")).catch((e) => null);
            let rebalanceInfos = basket.getFlashRebalanceInfo(this.tokenList, oraclePriceData, timestamp ? timestamp : 2000000000);
            rebalanceInfos.over = rebalanceInfos.over.sort((a, b) => b.value - a.value);
            rebalanceInfos.under = rebalanceInfos.under.sort((a, b) => b.value - a.value);
            let txsToSend = [];
            const lookupTableAccount = (yield this.connection.getAddressLookupTable(config_1.BASKETS_LOOKUP_TABLE)).value;
            //@ts-ignore
            let alls = [];
            console.log("CAP --- ", cap);
            for (let ov = 0; ov < rebalanceInfos.over.length; ov++) {
                for (let un = 0; un < rebalanceInfos.under.length; un++) {
                    // continue;
                    if (!forceRebalance && (rebalanceInfos.over[ov].iT && rebalanceInfos.under[un].iT))
                        continue;
                    if (!forceRebalance && (rebalanceInfos.over[ov].rR && rebalanceInfos.under[un].rR))
                        continue;
                    let from = rebalanceInfos.over[ov].token;
                    let to = rebalanceInfos.under[un].token;
                    if (from == 0 || to == 0)
                        continue;
                    let value = Math.min(rebalanceInfos.over[ov].value, rebalanceInfos.under[un].value) * 0.995;
                    // console.log(from, to, value);
                    value = Math.min(value, cap);
                    if (value == 0)
                        continue;
                    let rawAmount = value / oraclePriceData[from] * 10 ** this.tokenList[from].decimals;
                    let tokenAmount = Math.floor(rawAmount);
                    if (tokenAmount * 1.005 >= rebalanceInfos.over[ov].uM && rebalanceInfos.over[ov].uM != 0)
                        tokenAmount = rebalanceInfos.over[ov].uM;
                    if (value <= mIn)
                        continue;
                    if (value <= 0.01 && rebalanceInfos.over[ov].uM == 0)
                        continue;
                    // console.log(this.tokenList[from].symbol, "->" , this.tokenList[to].symbol);
                    // console.log(value);
                    yield (0, utils_1.delay)(700);
                    let data = yield (0, utils_1.generateJupTxData)(//@ts-ignore
                    this.wallet.publicKey, this.tokenList[from].tokenMint, this.tokenList[to].tokenMint, tokenAmount, basket.data.rebalanceSlippage.toNumber(), oraclePriceData[from] / 10 ** this.tokenList[from].decimals, oraclePriceData[to] / 10 ** this.tokenList[to].decimals).catch((e) => { console.log(e.message); return null; });
                    if (data && parseInt(data.res.inAmount) != tokenAmount) {
                        // console.log("->", data);
                        // console.log("ow", tokenAmount);
                        tokenAmount = parseInt(data.res.inAmount);
                    }
                    if (!data)
                        continue;
                    // rebalanceInfos.over[ov].value -= value;
                    // rebalanceInfos.under[un].value -= value;
                    let { addressLookupTableAddresses, swapInstruction, setupInstructions, res } = data;
                    setupInstructions = setupInstructions.map((ix) => {
                        return {
                            programId: new web3_js_1.PublicKey(ix.programId),
                            keys: ix.accounts.map((a) => { return Object.assign(Object.assign({}, a), { pubkey: new web3_js_1.PublicKey(a.pubkey) }); }),
                            data: Buffer.from(ix.data, "base64")
                        };
                    });
                    swapInstruction = {
                        programId: new web3_js_1.PublicKey(swapInstruction.programId),
                        keys: swapInstruction.accounts.map((a) => { return Object.assign(Object.assign({}, a), { pubkey: new web3_js_1.PublicKey(a.pubkey) }); }),
                        data: Buffer.from(swapInstruction.data, "base64")
                    };
                    let lookupTableAccounts = yield (0, utils_1.getAddressLookupTableAccounts)(this.connection, addressLookupTableAddresses);
                    let tx = {
                        payerKey: this.wallet.publicKey,
                        instructions: [
                            yield (0, instructionsBuilder_1.buildUpdateCurrentWeightsIx)(this.program, basket, this.tokenList),
                            ...setupInstructions,
                            yield (0, instructionsBuilder_1.buildWithdrawBeforeRebalanceIx)(//@ts-ignore
                            this.program, this.wallet.publicKey, basket, this.tokenList, from, to, tokenAmount),
                            swapInstruction,
                            yield (0, instructionsBuilder_1.buildDepositAfterRebalanceIx)(//@ts-ignore
                            this.program, this.wallet.publicKey, basket, this.tokenList, to),
                            web3_js_1.ComputeBudgetProgram.setComputeUnitLimit({ units: config_1.ADDITIONAL_UNITS }),
                            web3_js_1.ComputeBudgetProgram.setComputeUnitPrice({ microLamports: this.lamports })
                        ],
                        lookupTables: [...lookupTableAccounts, lookupTableAccount]
                    };
                    // if (setupInstructions.length != 0) continue;
                    // console.log(tx);
                    let blockhash = (yield this.connection.getLatestBlockhash("confirmed")).blockhash;
                    let signedTransactions = yield (0, utils_1.signVersionedTransactions)(//@ts-ignore
                    this.wallet, [new web3_js_1.VersionedTransaction(new web3_js_1.TransactionMessage({
                            payerKey: tx.payerKey,
                            recentBlockhash: blockhash,
                            instructions: tx.instructions,
                        }).compileToV0Message(tx.lookupTables))]);
                    let resultTxs = yield (0, utils_1.sendSignedTransactions)(this.connection, signedTransactions, 0);
                    console.log(resultTxs[0]);
                    alls.push(resultTxs[0]);
                    // txsToSend.push(tx);
                }
            }
            // let blockhash = (await this.connection.getLatestBlockhash()).blockhash;
            // let signedTransactions = await signVersionedTransactions(
            //     this.wallet,
            //     txsToSend.map(tx => new VersionedTransaction(
            //         new TransactionMessage({
            //             payerKey: tx.payerKey,
            //             recentBlockhash: blockhash,
            //             instructions: tx.instructions,
            //         }).compileToV0Message(tx.lookupTables)
            //     ))
            // );
            // let resultTxs = await sendSignedTransactions(
            //     this.connection,
            //     signedTransactions,
            //     0,
            // );
            let resultTxs = alls;
            // if (resultTxs.length > 0)
            //     await confirmTransaction(this.connection, resultTxs[resultTxs.length - 1]).catch(() => {});
            return resultTxs;
        });
    }
    buyBasket(basket, amountUsdc) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.wallet)
                throw new config_1.BasketError("Wallet not provided");
            return yield buyState_1.BuyState.createNew(this.program, this.wallet, this.tokenList, basket, amountUsdc, this.lamports);
        });
    }
    getOraclePrices() {
        return __awaiter(this, void 0, void 0, function* () {
            let oraclePrices = yield (0, utils_1.getOraclePrices)(this.program, this.tokenList);
            return oraclePrices;
        });
    }
    computeMintAmountWithMultipleTokens(basket, contribution) {
        return __awaiter(this, void 0, void 0, function* () {
            let oraclePrices = yield (0, utils_1.getOraclePrices)(this.program, this.tokenList);
            let amount = buyState_1.BuyState.computeMintAmountWithMultipleTokens(this.tokenList, basket, contribution, oraclePrices);
            return amount;
        });
    }
    buyBasketWithMultipleTokens(basket, contribution) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.wallet)
                throw new config_1.BasketError("Wallet not provided");
            return yield buyState_1.BuyState.multipleTokensDeposit(this.program, this.wallet, this.tokenList, basket, contribution, this.lamports);
        });
    }
    computeMintAmountWithSingleToken(basket, token, amount) {
        return __awaiter(this, void 0, void 0, function* () {
            let oraclePrices = yield (0, utils_1.getOraclePrices)(this.program, this.tokenList);
            let tokenSettings = this.tokenList.find(x => x.tokenMint == token.toBase58());
            if (!tokenSettings)
                throw new config_1.BasketError("Token not in composition");
            let exp = buyState_1.BuyState.computeMintAmountWithSingleToken(this.tokenList, basket, tokenSettings, amount, oraclePrices);
            return exp;
        });
    }
    buyWithSingleToken(basket, token, amount) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.wallet)
                throw new config_1.BasketError("Wallet not provided");
            return yield buyState_1.BuyState.singleTokenDeposit(this.program, this.wallet, this.tokenList, basket, token, amount, this.lamports);
        });
    }
    rebalanceBuyState(buyState) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.wallet)
                throw new config_1.BasketError("Wallet not provided");
            let oraclePriceData = yield (0, utils_1.getOraclePrices)(this.program, this.tokenList);
            let rebalanceInfos = buyState.getBuyStateRebalanceInfo(this.tokenList);
            let jupSwapDatas = yield Promise.all(rebalanceInfos.map(rebalanceInfo => (0, utils_1.generateJupSwapInstruction)(rebalanceInfo, buyState.basket.data.rebalanceSlippage.toNumber(), this.connection, rebalanceInfo.side == config_1.Side.To ?
                oraclePriceData[rebalanceInfo.tokenId] / 10 ** this.tokenList[rebalanceInfo.tokenId].decimals :
                oraclePriceData[0] / 10 ** this.tokenList[0].decimals, rebalanceInfo.side == config_1.Side.From ?
                oraclePriceData[rebalanceInfo.tokenId] / 10 ** this.tokenList[rebalanceInfo.tokenId].decimals :
                oraclePriceData[0] / 10 ** this.tokenList[0].decimals, rebalanceInfo.tokenId == 48 ? this.tokenList[5].tokenMint : this.tokenList[1].tokenMint, rebalanceInfo.tokenId == 48 ? this.tokenList[5].pdaTokenAccount : this.tokenList[1].pdaTokenAccount, this.jupAPIkey).catch((e) => { console.log("JUP SWAP DATA", e.message); return null; })));
            return yield buyState.rebalanceBuyState(this.program, this.wallet, this.tokenList, //@ts-ignore
            jupSwapDatas, this.lamports);
        });
    }
    mintBasket(buyState) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.wallet)
                throw new config_1.BasketError("Wallet not provided");
            return yield buyState.mint(this.program, this.wallet, this.tokenList, this.lamports);
        });
    }
    sellBasketToSingleToken(basket, withdrawToken, amount) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.wallet)
                throw new config_1.BasketError("Wallet not provided");
            return yield basket.sellBasketToSingleToken(this.program, this.wallet, this.tokenList, withdrawToken, amount, this.lamports);
        });
    }
    computeOutputAmountWithSingleToken(basket, withdrawToken, amount) {
        return __awaiter(this, void 0, void 0, function* () {
            let oraclePrices = yield (0, utils_1.getOraclePrices)(this.program, this.tokenList);
            let tokenSettings = this.tokenList.find(x => x.tokenMint == withdrawToken.toBase58());
            if (!tokenSettings)
                throw new config_1.BasketError("Token not in composition");
            let exp = basket.computeOutputAmountWithSingleToken(oraclePrices, this.tokenList, tokenSettings, amount);
            return exp;
        });
    }
    sellBasket(basket, amount, rebalance) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.wallet)
                throw new config_1.BasketError("Wallet not provided");
            return yield basket.sell(this.program, this.wallet, amount, rebalance, this.lamports);
        });
    }
    claimTokensFromBuyState(buyState) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.wallet)
                throw new config_1.BasketError("Wallet not provided");
            return yield buyState.claimTokens(this.program, this.wallet, this.tokenList, this.lamports);
        });
    }
    claimTokens(basket) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.wallet)
                throw new config_1.BasketError("Wallet not provided");
            return yield basket.claimTokens(this.program, this.wallet, this.tokenList, this.lamports);
        });
    }
    removeDust(basket) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.wallet)
                throw new config_1.BasketError("Wallet not provided");
            let oraclePriceData = yield (0, utils_1.getOraclePrices)(this.program, this.tokenList);
            return yield basket.removeDust(this.program, this.wallet, this.tokenList, oraclePriceData, this.lamports);
        });
    }
    freezeProgram() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (!this.wallet)
                throw new config_1.BasketError("Wallet not provided");
            let transaction = new web3_js_1.Transaction();
            transaction = transaction.add(yield this.program.methods.freezeProgram().accounts({
                owner: (_a = this.wallet) === null || _a === void 0 ? void 0 : _a.publicKey,
                tokenList: config_1.TOKEN_LIST_ADDRESS,
                systemProgram: web3_js_1.SystemProgram.programId,
            }).instruction());
            transaction = transaction.add(web3_js_1.ComputeBudgetProgram.setComputeUnitLimit({ units: config_1.ADDITIONAL_UNITS })).add(web3_js_1.ComputeBudgetProgram.setComputeUnitPrice({ microLamports: this.lamports }));
            let signedTransactions = yield (0, utils_1.signTransactionsWithWallet)(this.program.provider.connection, this.wallet, [{ transaction: transaction, signers: [] }]);
            return (yield (0, utils_1.sendSignedTransactions)(this.program.provider.connection, signedTransactions, 1))[0];
        });
    }
    unfreezeProgram() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (!this.wallet)
                throw new config_1.BasketError("Wallet not provided");
            let transaction = new web3_js_1.Transaction();
            transaction = transaction.add(yield this.program.methods.unfreezeProgram().accounts({
                owner: (_a = this.wallet) === null || _a === void 0 ? void 0 : _a.publicKey,
                tokenList: config_1.TOKEN_LIST_ADDRESS,
                systemProgram: web3_js_1.SystemProgram.programId,
            }).instruction());
            transaction = transaction.add(web3_js_1.ComputeBudgetProgram.setComputeUnitLimit({ units: config_1.ADDITIONAL_UNITS })).add(web3_js_1.ComputeBudgetProgram.setComputeUnitPrice({ microLamports: this.lamports }));
            let signedTransactions = yield (0, utils_1.signTransactionsWithWallet)(this.program.provider.connection, this.wallet, [{ transaction: transaction, signers: [] }]);
            return (yield (0, utils_1.sendSignedTransactions)(this.program.provider.connection, signedTransactions, 1))[0];
        });
    }
}
exports.BasketsSDK = BasketsSDK;
